/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import {
  SET_PASSWORD_REQUEST,
  SET_PASSWORD_SUCCESS,
  SET_PASSWORD_FAILURE,
  SET_PASSWORD_FOR_NEW_USER_REQUEST,
  SET_PASSWORD_FOR_NEW_USER_SUCCESS,
  SET_PASSWORD_FOR_NEW_USER_FAILURE,
  SET_NEWPASSWORD_REQUEST,
  SET_NEWPASSWORD_SUCCESS,
  SET_NEWPASSWORD_FAILURE,
} from "./setPasswordTypes";

import axios from "axios";
import Config from "../../../config/index";
let baseUrl = Config.baseUrl;
let userManagementUrl = Config.userManagementUrl;

const setPasswordRequest = () => {
  return {
    type: SET_PASSWORD_REQUEST,
  };
};

const setPasswordSuccess = (payload) => {
  return {
    type: SET_PASSWORD_SUCCESS,
    payload: payload,
  };
};

const setPasswordFaliure = (error) => {
  return {
    type: SET_PASSWORD_FAILURE,
    payload: error,
  };
};

const setPassword = (setPasswordState) => {
  return (dispatch) => {
    let payload = {
      email: setPasswordState.email,
      password: setPasswordState.newpassword,
    };
    dispatch(setPasswordRequest());
    let url = `${userManagementUrl}/user/reset_password`;
    return axios
      .put(url, setPasswordState)
      .then((response) => {
        dispatch(setPasswordSuccess(response.data));
        return { status: true };
      })
      .catch((err) => {
        dispatch(setPasswordFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const setPasswordForNewUserRequest = () => {
  return {
    type: SET_PASSWORD_FOR_NEW_USER_REQUEST,
  };
};

const setPasswordForNewUserSuccess = (payload) => {
  return {
    type: SET_PASSWORD_FOR_NEW_USER_SUCCESS,
    payload: payload,
  };
};

const setPasswordForNewUserFaliure = (error) => {
  return {
    type: SET_PASSWORD_FOR_NEW_USER_FAILURE,
    payload: error,
  };
};

const setPasswordForNewUser = (setPasswordState) => {
  return (dispatch) => {
    let payload = {
      email: setPasswordState.email,
      password: setPasswordState.newpassword,
    };
    dispatch(setPasswordForNewUserRequest());
    let url = `${userManagementUrl}/user/reset_password`;
    return axios
      .put(url, setPasswordState)
      .then((response) => {
        dispatch(setPasswordForNewUserSuccess(response.data));
        return { status: true };
      })
      .catch((err) => {
        dispatch(setPasswordForNewUserFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const setNewPasswordRequest = () => {
  return {
    type: SET_NEWPASSWORD_REQUEST,
  };
};

const setNewPasswordSuccess = (payload) => {
  return {
    type: SET_NEWPASSWORD_SUCCESS,
    payload: payload,
  };
};

const setNewPasswordFaliure = (error) => {
  return {
    type: SET_NEWPASSWORD_FAILURE,
    payload: error,
  };
};

const setNewPassword = (setNewPasswordState) => {
  return (dispatch) => {
    dispatch(setNewPasswordRequest());
    let url = `${userManagementUrl}/user/reset_password`;
    return axios
      .put(url, setNewPasswordState)
      .then((response) => {
        dispatch(setNewPasswordSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(setNewPasswordFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export { setPassword, setPasswordForNewUser, setNewPassword };
